import React from 'react';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { Provider } from 'react-redux';
import { persistor, store } from './redux/store';
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import Router from './routes';
import '@fontsource/plus-jakarta-sans';
import './style.css';

require('./utils/Pusher');

export default function App() {
  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <BaseOptionChartStyle />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <div className="app-container">
            <Router />
          </div>
        </PersistGate>
      </Provider>
    </ThemeConfig>
  );
}
